export default __webpack_public_path__ + "static/media/knarley.01932ed9.png";